import { getEdgeRegionHint } from '@atlassian/search-common';

import type { BootstrapVariables } from '../../../common/constants/relay/types';
import { serveRegionSteeringExperiment } from '../../../common/utils/experiments';

type getRelayFetchOptionsArgs = {
	primaryProduct: BootstrapVariables['primaryProduct'];
	productDataRegions: BootstrapVariables['productDataRegions'];
};

export function getRelayFetchOptions({
	primaryProduct,
	productDataRegions,
}: getRelayFetchOptionsArgs):
	| {
			networkCacheConfig: {
				metadata: {
					headers: {
						'atl-edge-region-hint': string | undefined;
					};
				};
			};
	  }
	| undefined {
	if (serveRegionSteeringExperiment()) {
		const edgeRegionHint =
			primaryProduct && productDataRegions
				? getEdgeRegionHint(primaryProduct, productDataRegions)
				: undefined;

		return {
			networkCacheConfig: {
				metadata: {
					headers: {
						'atl-edge-region-hint': edgeRegionHint,
					},
				},
			},
		};
	} else {
		return undefined;
	}
}
